import { apiRequest } from '../utils/api';

const BASE = '/api/asset-code-tokens';

export const listTokens = () => apiRequest(BASE);

export const composeCode = (name) =>
  apiRequest(`${BASE}/compose`, { method: 'POST', body: JSON.stringify({ name }) });

export const createToken = (payload) =>
  apiRequest(BASE, { method: 'POST', body: JSON.stringify(payload) });

export const updateToken = (id, payload) =>
  apiRequest(`${BASE}/${id}`, { method: 'PUT', body: JSON.stringify(payload) });

export const deleteToken = (id) =>
  apiRequest(`${BASE}/${id}`, { method: 'DELETE' });
